import { all } from "redux-saga/effects";

import accounts from "./accounts/saga";
import altAssets from "./alt-assets/saga";
import assetFoundElsewhere from "./asset-found-elsewhere/saga";
import assets from "./assets/saga";
import assignmentDetails from "./assignment-details/saga";
import assetLookup from "./asset-lookup/saga";
import assetSync from "./asset-sync/saga";
import auditArchive from "./audit-archive/saga";
import auditAssets from "./audit-assets/saga";
import auditAssignments from "./audit-assignments/saga";
import auditControllers from "./audit-controllers/saga";
import auditFilters from "./audit-filters/saga";
import auditGroups from "./audit-groups/saga";
import auditImages from "./audit-images/saga";
import auditResendAssignmentEmail from "./audit-resend-assignment-email/saga";
import auditRating from "./audit-rating/saga";
import auditReview from "./audit-review/saga";
import audits from "./audits/saga";
import auditsList from "./audits-list/saga";
import auditsCreate from "./audits-create/saga";
import auditSubmissions from "./audit-submissions/saga";
import auth from "./auth/saga";
import branches from "./branches/saga";
import branchLocations from "./branch-locations/saga";
import dealerContacts from "./dealer-contacts/saga";
import dashboard from "./dashboard-store/saga";
import dataCheck from "./data-check/saga";
import financeTypes from "./finance-types/saga";
import locations from "./locations/saga";
import organisations from "./organisations/saga";
import organisationSettings from "./organisation-settings/saga";
import powerbi from "./powerbi/saga";
import toast from "./toast/saga";
import typesList from "./types-list/saga";
import userLanguage from "./user-language/saga";
import userLocations from "./user-locations/saga";
import userOrganisations from "./user-organisations/saga";
import userWelcomeRequest from "./user-welcome-requests/saga";
import validationErrors from "./validation-errors/saga";
import validatedVisibility from "./validated-visibility-assets/saga";
import auditComment from "./audit-comment/saga";
import skipTrace from "./skip-trace/saga";
import vinDecoder from "./vin-decoder/saga";

/**
 * Root Saga
 */
export default function* () {
    yield all([
        accounts(),
        altAssets(),
        assetFoundElsewhere(),
        assets(),
        assetSync(),
        assetLookup(),
        assignmentDetails(),
        auditArchive(),
        auditAssets(),
        auditControllers(),
        auditAssignments(),
        auditFilters(),
        auditGroups(),
        auditImages(),
        auditResendAssignmentEmail(),
        auditRating(),
        auditReview(),
        auditsList(),
        audits(),
        auditsCreate(),
        auditComment(),
        auditSubmissions(),
        auth(),
        branches(),
        branchLocations(),

        dashboard(),
        dataCheck(),
        dealerContacts(),
        financeTypes(),
        locations(),
        organisations(),
        organisationSettings(),
        powerbi(),
        skipTrace(),
        toast(),
        typesList(),
        userLanguage(),
        userLocations(),
        userOrganisations(),
        userWelcomeRequest(),
        validationErrors(),
        validatedVisibility(),
        vinDecoder()
    ]);
}
